<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="4" lg="3">
                <search-bar-instant v-model="query.searchString" />
            </v-col>
            <v-col cols="12" md="4" lg="3">
                <filter-bar-instant
                    label="Courier statuses"
                    v-bind:items="filterItems"
                    v-model="query.courierStatuses"
                />
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="8" lg="6">
                <courier-list-item
                    class="mb-4"
                    v-for="item in listItems"
                    v-bind:key="item.id"
                    v-bind:courierinfo="item"
                    v-on:request-show="onRequestShow"
                    v-on:request-edit="onRequestEdit"
                    v-on:request-delete="onRequestDelete"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import courierApi from '@/api/courierApi';
import * as courierStatuses from '@/constants/courierStatuses';
import snackbar from '@/utils/snackbar';
import statusUtil from '@/utils/statusUtil';

export default {
    components: {
        'courier-list-item': () => import('@/views/op/CourierListItem.vue'),
        'search-bar-instant': () => import('@/components/SearchBarInstant.vue'),
        'filter-bar-instant': () => import('@/components/FilterBarInstant.vue')
    },
    data() {
        return {
            courierinfos: [],
            query: {
                searchString: null,
                courierStatuses: []
            },
            filterItems: [
                { text: 'Available', value: courierStatuses.AVAILABLE },
                { text: 'Servicing', value: courierStatuses.SERVICING },
                { text: 'Off-duty', value: courierStatuses.OFF_DUTY }
            ]
        };
    },
    computed: {
        listItems() {
            let finalList = this.courierinfos.filter(function(courierinfo) {
                let result = true;

                // Search string
                const search =
                    this.query.searchString &&
                    this.query.searchString.trim().toLowerCase();
                if (search && courierinfo.user) {
                    result =
                        result &&
                        courierinfo.user.name.toLowerCase().includes(search);
                }

                // Courier statuses
                if (
                    this.query.courierStatuses &&
                    this.query.courierStatuses.length > 0
                ) {
                    result =
                        result &&
                        this.query.courierStatuses.includes(courierinfo.status);
                }

                return result;
            }, this);

            return finalList.sort(statusUtil.compareCouriersByStatus);
        }
    },
    async beforeRouteEnter(to, from, next) {
        const response = await courierApi.getCouriers();
        next(vm => (vm.courierinfos = response.data.courierinfos));
    },
    methods: {
        onRequestShow(courierinfo) {
            this.$router.push({
                name: 'op-courierinfo-show',
                params: {
                    courierinfo_id: courierinfo.id
                }
            });
        },
        onRequestEdit(courierinfo) {
            this.$router.push({
                name: 'op-courierinfo-edit',
                params: {
                    courierinfo_id: courierinfo.id
                }
            });
        },
        async onRequestDelete(courierinfo) {
            const confirmed = confirm('Confirm deletion');
            if (!confirmed) return;
            await courierApi.deleteCourier(courierinfo.id);
            const index = this.courierinfos.indexOf(courierinfo);
            this.courierinfos.splice(index, 1);
            snackbar.show('Deleted successfully', 'success');
        }
    }
};
</script>
